// Google Analytics — só o nome da tela, mais nada.
//
// O 82 é uma página só: o endereço nunca muda enquanto a pessoa joga. Sem
// avisar a cada troca de tela, o GA registraria UMA visualização por sessão e
// nunca diria onde as pessoas ficam, onde desistem, ou se o mercado é usado.
//
// ⚠️ NUNCA mande dado pessoal daqui. Nem e-mail, nem nome, nem WhatsApp — nem
// dentro do "título" da tela. Analytics é um serviço de fora; o que entra ali
// sai do nosso controle. O que vai é o nome da tela e nada mais.
//
// Tudo aqui tolera o gtag não existir: bloqueador de anúncios, rede caindo, ou
// a pessoa recusando cookies. Medir não pode quebrar o jogo.

const NOMES = {
  home: 'Início',
  liga: 'Escolha da liga',
  clube: 'Escolha do clube',
  comojogar: 'Como jogar',
  premium: 'Premium',
  ceo: 'Painel CEO',
  painel: 'Painel do clube',
  elenco: 'Elenco',
  mercado: 'Mercado',
  tabela: 'Tabela',
  jogos: 'Jogos',
  galeria: 'Troféus',
  draft: 'Draft',
  vagas: 'Vagas',
  escalacao: 'Tática e escalação',
  aovivo: 'Partida ao vivo',
};

const enviar = (evento, dados) => {
  try {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('event', evento, dados);
  } catch { /* medir nunca pode derrubar o jogo */ }
};

let ultima = null;

/**
 * Avisa que a pessoa está numa tela.
 *
 * Repetição é ignorada: o React redesenha várias vezes por segundo durante uma
 * partida, e sem esta guarda o GA receberia centenas de visualizações da mesma
 * tela — o relatório viraria ruído.
 */
export function verTela(id) {
  if (!id || id === ultima) return;
  ultima = id;
  enviar('page_view', {
    page_title: NOMES[id] || id,
    // O caminho é inventado a partir da tela, não lido do endereço: o endereço
    // é sempre o mesmo. Assim o relatório de páginas do GA fica legível.
    page_location: `${location.origin}${location.pathname}#${id}`,
    page_path: `${location.pathname}#${id}`,
  });
}

/** Marcos que valem olhar depois: começou carreira, jogou, comprou. */
export const marcar = (evento, dados = {}) => enviar(evento, dados);
